import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import DataSource from '../../tradingPlanFormComponents/FieldComponents/DataSource';
import Brokerage from '../../tradingPlanFormComponents/FieldComponents/Brokerage';
import Account from '../../tradingPlanFormComponents/FieldComponents/Account';
import GoLongShort from '../../tradingPlanFormComponents/FieldComponents/GoLongShort';
import Symbol from '../../tradingPlanFormComponents/FieldComponents/Symbol';
import WorkOrders from '../../tradingPlanFormComponents/FieldComponents/workOrders/WorkOrders';
import QuantityBasis from '../../tradingPlanFormComponents/FieldComponents/QuantityBasis';
import Instrument from '../../tradingPlanFormComponents/FieldComponents/Instrument';
import Setup from '../../tradingPlanFormComponents/FieldComponents/Setup';
import { setUpOptions } from '../../tradingPlanFormComponents/hooks/setup/SetupHooks';
import EntryTacticSummaryBox from '../../tradingPlanFormComponents/FieldComponents/EntryTacticSummaryBox';
import PositionTacticSummaryBox from '../../tradingPlanFormComponents/FieldComponents/PositionTacticsSummaryBox';
import ExitTacticSummaryBox from '../../tradingPlanFormComponents/FieldComponents/ExitTacticsSummaryBox';
import { Box, Divider, FormControlLabel, Typography } from '@material-ui/core';
import SetupFiltersTree from '../../tradingPlanFormComponents/FieldComponents/SetupFiltersTree';
import SelectExpirationDates from '../../tradingPlanFormComponents/FieldComponents/ExpirationDates';
import RenderOptionChains, {
  CreateSubscriptionForOptionChains,
  OptionShortCutsCheckBoxes,
} from '../../tradingPlanFormComponents/FieldComponents/OptionChains';
import DisplayOptionChoices from '../../tradingPlanFormComponents/FieldComponents/DisplayOptionChoices';
import StartPeriodHourMin from '../../tradingPlanFormComponents/FieldComponents/StartPeriodHourMin';
import PushMessage from '../../../../displays/pushmessages/PushMessage';
import ReactHotkeys from 'react-hot-keys';
import { dataValidation } from '../DataValidation';
import TemplateFunctionsContainer from '../../templateFunctions/TemplateFunctionsContainer';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import CheckBox from '../../../../atomic/formElements/checkBox/CheckBox';
import style from './TradePlanForm.module.css';
import { colors } from '../../../../../colorVars';
import FrontRun from '../../tradingPlanFormComponents/FieldComponents/frontRun/FrontRun';
import Repeating from '../../tradingPlanFormComponents/FieldComponents/repeating/Repeating';
import ExitTacticsContainer from '../../tradingPlanFormComponents/FieldComponents/exitTactics/exitTacticsContainer/ExitTacticsContainer';
import TradePlanTitleWrapper from '../../../../atomic/formElements/tradePlanTitleWrapper/TradePlanTitleWrapper';
import EntryTacticsContainer from '../../tradingPlanFormComponents/FieldComponents/entryTactics/entryTacticsContainer/EntryTacticsContainer';
import PositionTacticsContainer from '../../tradingPlanFormComponents/FieldComponents/positionTactics/positionTacticsContainer/PositionTacticsContainer';
import { addTradePlan } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/addtradeplanmessage/addTradePlan';

const boxProps = {
  bgcolor: 'background.paper',
  m: 1,
  borderColor: 'text.primary',
};

const TradePlanForm = ({
  finishedRenderingOptionChain,
  setFinishedRenderingOptionChain,
  optionShortCutRefs,
  clearForm,
  setClearForm,
  setTpOpen,
  setRefreshedForm,
  savedConfigurations,
  setSelectedSavedConfig,
  updatedSavedTp,
  setUpdatedSavedTp,
  storedEntryConfigurations,
  packageOfSetters,
  userPreferences,
  setTpDrawerOpen,
  drawerOpen,
  focusRef,
  submitMessageDetails,
  setSubmitMessageDetails,
  clickedSubmit,
  setClickedSubmit,
  symbolsUsed,
  setSymbolsUsed,
  symbolsRemaining,
  mutableSymbol,
  storedConfigKey,
  configTitle,
  top,
  dispatchTop,
  data,
  optionChoices,
  setOptionChoices,
  optionChains,
  setOptionChains,
  expirationDates,
  setExpirationDates,
  notExpiringToday,
  setNotExpiringToday,
  maxOptionPriceBarrier,
  setMaxOptionPriceBarrier,
  minOptionPriceBarrier,
  setMinOptionPriceBarrier,
  tightSpreadPctEnabled,
  tightSpreadPct,
  dispatchTightSpreadPct,
  optionPriceRangeEnabled,
  optionPriceRange,
  dispatchOptionPriceRange,
  qtyRangeEnabled,
  setQtyRangeEnabled,
  dollarRangeEnabled,
  setDollarRangeEnabled,
  qtyRange,
  dispatchQtyRange,
  dollarRange,
  dispatchDollarRange,
  marketOrder,
  dispatchMarketOrder,
  marketOrderEnabled,
  setMarketOrderEnabled,
  candleBreak,
  dispatchCandleBreak,
  candleBreakEnabled,
  setCandleBreakEnabled,
  limitOrder,
  dispatchLimitOrder,
  limitOrderEnabled,
  setLimitOrderEnabled,
  scalingIn,
  dispatchScalingIn,
  scalingInEnabled,
  setScalingInEnabled,
  addToWinner,
  dispatchAddToWinner,
  addToWinnerEnabled,
  setAddToWinnerEnabled,
  lossLimit,
  dispatchLossLimit,
  lossLimitEnabled,
  setLossLimitEnabled,
  preserveProfit,
  dispatchPreserveProfit,
  preserveProfitEnabled,
  setPreserveProfitEnabled,
  positionPriceTrail,
  dispatchPositionPriceTrail,
  positionPriceTrailEnabled,
  setPositionPriceTrailEnabled,
  underlyingPriceTrail,
  dispatchUnderlyingPriceTrail,
  underlyingPriceTrailEnabled,
  setUnderlyingPriceTrailEnabled,
  candleTrail,
  dispatchCandleTrail,
  candleTrailEnabled,
  setCandleTrailEnabled,
  grabCents,
  dispatchGrabCents,
  grabCentsEnabled,
  setGrabCentsEnabled,
  grabCentsMode,
  setGrabCentsMode,
  greenToRedCandles,
  dispatchGreenToRedCandles,
  greenToRedCandlesEnabled,
  setGreenToRedCandlesEnabled,
  greenToRedPositions,
  dispatchGreenToRedPositions,
  greenToRedPositionsEnabled,
  setGreenToRedPositionsEnabled,
  breakPrice,
  dispatchBreakPrice,
  breakPriceEnabled,
  setBreakPriceEnabled,
  positionBreakPrice,
  dispatchPositionBreakPrice,
  positionBreakPriceEnabled,
  setPositionBreakPriceEnabled,
  candleMagnitude,
  dispatchCandleMagnitude,
  candleMagnitudeEnabled,
  setCandleMagnitudeEnabled,
  ratchetBracket,
  dispatchRatchetBracket,
  ratchetBracketEnabled,
  setRatchetBracketEnabled,
  setupFields,
  setupDetails,
  dispatchSetUpDetails,
  setConfigTitle,
  selectedSavedConfig,
  optionShortCutsPackage,
  setTightSpreadPctEnabled,
  tightSpreadCentsEnabled,
  setTightSpreadCentsEnabled,
  setOptionPriceRangeEnabled,
  tightSpreadCents,
  dispatchTightSpreadCents,
  hugCurrentPriceEnabled,
  setHugCurrentPriceEnabled,
  hugCurrentPrice,
  dispatchHugCurrentPrice,
  setViewOptionManagementEnabled,
  buyOrSellOption,
  setBuyOrSellOption,
  otm,
  setOtm,
  itm,
  setItm,
  otm1Enabled,
  setOtm1Enabled,
  otm1,
  dispatchOtm1,
  itm1Enabled,
  setItm1Enabled,
  itm1,
  dispatchItm1,
  priceIntersectsFirstCandleEnabled,
  setPriceIntersectsFirstCandleEnabled,
  priceIntersectsFirstCandle,
  dispatchPriceIntersectsFirstCandle,
  emaIntersectsFirstCandleEnabled,
  setEmaIntersectsFirstCandleEnabled,
  emaIntersectsFirstCandle,
  dispatchEmaIntersectsFirstCandle,
  timeOfDay,
  dispatchTimeOfDay,
  timeOfDayEnabled,
  setTimeOfDayEnabled,
  ftfcFilter,
  dispatchFtfcFilter,
  ftfcFilterEnabled,
  setFtfcFilterEnabled,
  savedConfigChanged: isSavedConfigDirty,
  setSavedConfigChanged,
  restartSettings,
  setRestartSettings,
  atrTrail,
  dispatchAtrTrail,
  atrTrailEnabled,
  setAtrTrailEnabled,
  mfeRetracementEnabled,
  setMfeRetracementEnabled,
  mfeRetracement,
  dispatchMfeRetracement,
  underlyingPriceExitEnabled,
  setUnderlyingPriceExitEnabled,
  underlyingPriceExit,
  dispatchUnderlyingPriceExit,
}) => {
  //const [settingDefaultConfig, setSettingDefaultConfig] = useState(false);
  //const [doneSettingDefaultConfig, setDoneSettingDefaultConfig] = useState(false);

  const [optionsAvailable, setOptionsAvailable] = useState(0);
  const goLongShortCut = 'alt+l';
  const goShortShortCut = 'alt+s';
  const enterShortCut = 'enter';
  const shortcutKeyActions = {
    [goLongShortCut]: { action: () => dispatchTop({ goLong: !top.goLong }) },
    [goShortShortCut]: { action: () => dispatchTop({ goShort: !top.goShort }) },
    [enterShortCut]: { action: (ev) => EnterTradePlan(ev) },
  };

  function EnterTradePlan(evt) {
    //if (submitFunction === AddTradePlan) {
    const [validForm, message] = dataValidation(
      data,
      symbolsRemaining,
      finishedRenderingOptionChain
    );
    if (!validForm) {
      //alert(message);
      evt.preventDefault();
      setClickedSubmit(true);
      setSubmitMessageDetails({
        severityScore: 'error',
        message: message,
      });
      return;
    }
    //}
    evt.preventDefault();     // TODO what does this do?
    if (data.optionManagement !== undefined) {
      data.optionManagement.notExpiringToday = undefined; //this is ONLY so frontend can use this. no need to pass to backend
    }
    //provide datasource so tradeplan can setup options from within json converter
    if (data.optionManagement !== undefined) {
      if (data.optionManagement.optionChoices !== undefined) {
        data.optionManagement.optionChoices.dataSource = data.dataSource;
      }
    }
    //savedConfigChanged
    // if (!isSavedConfigDirty) {
    data['savedConfigurationTitle'] = configTitle;
    //}
    addTradePlan({
      tradePlanObject: data,
      key: storedConfigKey,
      configName: configTitle,
    });
    setClickedSubmit(true);
    setSubmitMessageDetails({
      severityScore: 'success',
      message: 'submitted',
    });
  }

  const onKeyDown = (keyName, e, handle) => {
    shortcutKeyActions[keyName].action(e);
  };
  const multipleEntryTactics =
    data.entryTactics !== undefined &&
    Object.keys(data.entryTactics).length > 1;
  const multiplePositionTactics =
    data.positionTactics !== undefined &&
    Object.keys(data.positionTactics).length > 0;
  const showTerminateWhenFlat = multiplePositionTactics || multipleEntryTactics;
  if (!showTerminateWhenFlat && !top.terminateWhenFlat) {
    dispatchTop({ terminateWhenFlat: true });
  }
  return (
    <ReactHotkeys
      keyName={goLongShortCut + ',' + goShortShortCut + ',' + enterShortCut}
      onKeyDown={onKeyDown}
    >
      <form
        className={style.form}
        align-content="left"
        id="tpForm"
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
          }
        }}
        onChange={() => {
          if (!isSavedConfigDirty) {
            setSavedConfigChanged(true);
          }
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          // alignItems="center"
          spacing={0}
        >
          <TemplateFunctionsContainer
            data={data}
            packageOfSetters={packageOfSetters}
            mutableSymbol={mutableSymbol}
            savedConfigurations={savedConfigurations}
            updatedSavedTp={updatedSavedTp}
            setUpdatedSavedTp={setUpdatedSavedTp}
            savedConfigChanged={isSavedConfigDirty}
            setSavedConfigChanged={setSavedConfigChanged}
            setClearForm={setClearForm}
            setRefreshedForm={setRefreshedForm}
            setConfigTitle={setConfigTitle}
            configTitle={configTitle}
            setSelectedSavedConfig={setSelectedSavedConfig}
          />
          <div className={style.submitButtons}>
            <TextButton
              clickHandler={EnterTradePlan}
              color="white"
              backgroundColor={colors.green}
              width="90%"
              fontSize="large"
            >
              Create Trade Plan
            </TextButton>
          </div>
          <Grid item container direction="row">
            <Grid item xs={6}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
              >
                <GoLongShort
                  top={top}
                  dispatchTop={dispatchTop}
                  usedSymbols={[symbolsUsed, setSymbolsUsed]}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
              >
                <QuantityBasis
                  defaultQtyBasis={storedEntryConfigurations.qtyBasisValues}
                  top={top}
                  dispatchTop={dispatchTop}
                  marketOrder={[
                    marketOrder,
                    dispatchMarketOrder,
                    marketOrderEnabled,
                    setMarketOrderEnabled,
                  ]}
                  candleBreak={[
                    candleBreak,
                    dispatchCandleBreak,
                    candleBreakEnabled,
                    setCandleBreakEnabled,
                  ]}
                  limitOrder={[
                    limitOrder,
                    dispatchLimitOrder,
                    limitOrderEnabled,
                    setLimitOrderEnabled,
                  ]}
                  scalingIn={[
                    scalingIn,
                    dispatchScalingIn,
                    scalingInEnabled,
                    setScalingInEnabled,
                  ]}
                  addToWinner={[
                    addToWinner,
                    dispatchAddToWinner,
                    addToWinnerEnabled,
                    setAddToWinnerEnabled,
                  ]}
                  lossLimit={[
                    lossLimit,
                    dispatchLossLimit,
                    lossLimitEnabled,
                    setLossLimitEnabled,
                  ]}
                  preserveProfit={[
                    preserveProfit,
                    dispatchPreserveProfit,
                    preserveProfitEnabled,
                    setPreserveProfitEnabled,
                  ]}
                  positionPriceTrail={[
                    positionPriceTrail,
                    dispatchPositionPriceTrail,
                    positionPriceTrailEnabled,
                    setPositionPriceTrailEnabled,
                  ]}
                  underlyingPriceTrail={[
                    underlyingPriceTrail,
                    dispatchUnderlyingPriceTrail,
                    underlyingPriceTrailEnabled,
                    setUnderlyingPriceTrailEnabled,
                  ]}
                  candleTrail={[
                    candleTrail,
                    dispatchCandleTrail,
                    candleTrailEnabled,
                    setCandleTrailEnabled,
                  ]}
                  atrTrail={[
                    atrTrail,
                    dispatchAtrTrail,
                    atrTrailEnabled,
                    setAtrTrailEnabled,
                  ]}
                  underlyingPriceExit={[
                    underlyingPriceExitEnabled,
                    setUnderlyingPriceExitEnabled,
                    underlyingPriceExit,
                    dispatchUnderlyingPriceExit,
                  ]}
                  mfeRetracement={[
                    mfeRetracementEnabled,
                    setMfeRetracementEnabled,
                    mfeRetracement,
                    dispatchMfeRetracement,
                  ]}
                  grabCents={[
                    grabCents,
                    dispatchGrabCents,
                    grabCentsEnabled,
                    setGrabCentsEnabled,
                    grabCentsMode,
                    setGrabCentsMode,
                  ]}
                  greenToRedCandles={[
                    greenToRedCandles,
                    dispatchGreenToRedCandles,
                    greenToRedCandlesEnabled,
                    setGreenToRedCandlesEnabled,
                  ]}
                  greenToRedPositions={[
                    greenToRedPositions,
                    dispatchGreenToRedPositions,
                    greenToRedPositionsEnabled,
                    setGreenToRedPositionsEnabled,
                  ]}
                  breakPrice={[
                    breakPrice,
                    dispatchBreakPrice,
                    breakPriceEnabled,
                    setBreakPriceEnabled,
                  ]}
                  positionBreakPrice={[
                    positionBreakPrice,
                    dispatchPositionBreakPrice,
                    positionBreakPriceEnabled,
                    setPositionBreakPriceEnabled,
                  ]}
                  candleMagnitude={[
                    candleMagnitude,
                    dispatchCandleMagnitude,
                    candleMagnitudeEnabled,
                    setCandleMagnitudeEnabled,
                  ]}
                  ratchetBracket={[
                    ratchetBracket,
                    dispatchRatchetBracket,
                    ratchetBracketEnabled,
                    setRatchetBracketEnabled,
                  ]}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item container>
            {data.instrument === 'option' ? (
              <>
                <Grid item xs={12}>
                  <OptionShortCutsCheckBoxes
                    optionShortCutRefs={optionShortCutRefs}
                    optionShortCutsPackage={optionShortCutsPackage}
                    highBarrier={maxOptionPriceBarrier}
                    lowBarrier={minOptionPriceBarrier}
                    optionChoices={optionChoices}
                    setOptionChoices={setOptionChoices}
                    optionChains={optionChains}
                    finishedRenderingOptionChain={finishedRenderingOptionChain}
                    setFinishedRenderingOptionChain={
                      setFinishedRenderingOptionChain
                    }
                    showAllOptionsSelect={true}
                    ds={top.dataSource}
                    goLong={top.goLong}
                    goShort={top.goShort}
                    symbol={top.symbol}
                    expirationDates={expirationDates}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
            <Grid item xs={3}>
              <Symbol
                top={top}
                dispatchTop={dispatchTop}
                componentSymbol={mutableSymbol}
                setOptionChoices={setOptionChoices}
                setOptionChains={setOptionChains}
                finishedRenderingOptionChain={finishedRenderingOptionChain}
                setFinishedRenderingOptionChain={
                  setFinishedRenderingOptionChain
                }
              />
            </Grid>
            {data.instrument === 'option' ? (
              <>
                <Grid item xs={3}>
                  <SelectExpirationDates
                    symbol={top.symbol}
                    brokerage={top.brokerage}
                    dataSource={top.dataSource}
                    expirationDates={expirationDates}
                    setExpirationDates={setExpirationDates}
                    notExpiringToday={notExpiringToday}
                    symbolsUsed={symbolsUsed}
                    setSymbolsUsed={setSymbolsUsed}
                    isMulti={true}
                    numOfDefaultSelected={2}
                    setOptionChains={setOptionChains}
                    startingIndex={0}
                    showStrikesMessage={false}
                    highBarrier={maxOptionPriceBarrier}
                    setHighBarrier={setMaxOptionPriceBarrier}
                    lowBarrier={minOptionPriceBarrier}
                    setLowBarrier={setMinOptionPriceBarrier}
                    //fetch={props.fetch}
                  />
                </Grid>
                <Grid item xs={3}>
                  <CreateSubscriptionForOptionChains
                    symbol={top.symbol}
                    dataSource={top.dataSource}
                    expirationDates={expirationDates}
                    brokerage={top.brokerage} 
                    optionChains={[optionChains, setOptionChains]}
                    finishedRenderingOptionChain={finishedRenderingOptionChain}
                    setFinishedRenderingOptionChain={
                      setFinishedRenderingOptionChain
                    }
                  />
                  <RenderOptionChains
                    top={top}
                    expirationDates={expirationDates}
                    optionChoices={[optionChoices, setOptionChoices]}
                    setSymbolsUsed={setSymbolsUsed}
                    optionChains={[optionChains, setOptionChains]}
                    selectSingle={false}
                    finishedRenderingOptionChain={finishedRenderingOptionChain}
                    setFinishedRenderingOptionChain={
                      setFinishedRenderingOptionChain
                    }
                    displayOptionComponent={DisplayOptionChoices}
                    tightSpread={[
                      tightSpreadPctEnabled,
                      tightSpreadPct,
                      dispatchTightSpreadPct,
                    ]}
                    optionPriceRange={[
                      optionPriceRangeEnabled,
                      optionPriceRange,
                      dispatchOptionPriceRange,
                    ]}
                    showSelectedOptions={true}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
          <Grid item container>
            <Grid item xs={3}>
              <EntryTacticSummaryBox
                marketOrder={data.entryTactics.MARKET_ORDER}
                limitOrder={data.entryTactics.LIMIT_ORDER}
                candleBreak={data.entryTactics.CANDLE_BREAK}
              />
            </Grid>
            <Grid item xs={3}>
              <PositionTacticSummaryBox
                addToWinner={
                  data.positionTactics !== undefined
                    ? data.positionTactics.ADD_TO_WINNER
                    : undefined
                }
                scalingIn={
                  data.positionTactics !== undefined
                    ? data.positionTactics.SCALING_IN
                    : undefined
                }
              />
            </Grid>
            <Grid item xs={6}>
              <ExitTacticSummaryBox
                lossLimit={data.exitTactics.LOSS_LIMIT}
                preserveProfit={data.exitTactics.PRESERVE_PROFIT}
                underlyingPriceTrail={data.exitTactics.UNDERLYING_PRICE_TRAIL}
                positionPriceTrail={data.exitTactics.POSITION_PRICE_TRAIL}
                candleTrail={data.exitTactics.CANDLE_TRAIL}
                atrTrail={data.exitTactics.ATR_TRAIL}
                underlyingPriceExit={data.exitTactics.UNDERLYING_PRICE_EXIT}
                grabCents={data.exitTactics.GRAB_CENTS}
                greenToRedCandles={data.exitTactics.GREEN_TO_RED_CANDLES}
                greenToRedPositions={data.exitTactics.GREEN_TO_RED_POSITIONS}
                breakPrice={data.exitTactics.BREAK_PRICE}
                positionBreakPrice={data.exitTactics.POSITION_BREAK_PRICE}
                candleMagnitude={data.exitTactics.CANDLE_MAGNITUDE}
                ratchetBracket={data.exitTactics.RATCHET_BRACKET}
                mfeRetracement={data.exitTactics.MFE_RETRACEMENT}
              />
            </Grid>
          </Grid>
          <Grid item>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="stretch"
              border={1}
              {...boxProps}
            >
              <DataSource
                top={top}
                dispatchTop={dispatchTop}
                setOptionChoices={setOptionChoices}
                setOptionChains={setOptionChains}
                setSavedConfigChanged={setSavedConfigChanged}
              />
            </Box>
          </Grid>
          <Grid
            item
            container
            direction="row"
            //justify="center"
            //alignItems="center"
          >
            <Grid item xs={5}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
              >
                <Brokerage
                  top={top}
                  dispatchTop={dispatchTop}
                  setSavedConfigChanged={setSavedConfigChanged}
                />
              </Box>
            </Grid>
            <Grid item xs={7}>
              <Box
                display="flex"
                //flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
              >
                <Account top={top} dispatchTop={dispatchTop} />
              </Box>
            </Grid>
          </Grid>

          <hr />
          <div className={style.splitWrapper}>
            <TradePlanTitleWrapper title="Work Orders">
              <WorkOrders top={top} dispatchTop={dispatchTop} />
            </TradePlanTitleWrapper>
            <div className={style.verticalDivider} />
            <TradePlanTitleWrapper title="Entry/Exit Options" rightSplit>
              <FrontRun
                top={top}
                dispatchTop={dispatchTop}
                showTerminateWhenFlat={showTerminateWhenFlat}
              />
            </TradePlanTitleWrapper>
          </div>
          <hr />
          <TradePlanTitleWrapper title="Restart Settings">
            <Repeating
              top={top}
              dispatchTop={dispatchTop}
              restartSettings={restartSettings}
              setRestartSettings={setRestartSettings}
            />
          </TradePlanTitleWrapper>
          <hr />
          <Grid item container xs={12}>
            <Grid item xs={12}>
              <Box
                display="flex"
                flexDirection="column"
                //alignItems="stretch"
                border={1}
                padding={1}
                {...{
                  bgcolor: 'background.paper',
                  m: 1,
                  borderColor: 'text.primary',
                  //width: "100%"
                }}
              >
                <Instrument
                  defaultQtyBasis={storedEntryConfigurations.qtyBasisValues}
                  dispatchMarketOrder={dispatchMarketOrder}
                  dispatchLimitOrder={dispatchLimitOrder}
                  dispatchCandleBreak={dispatchCandleBreak}
                  optionsAvailable={optionsAvailable}
                  top={top}
                  dispatchTop={dispatchTop}
                  optionsManagement={[
                    tightSpreadPctEnabled,
                    setTightSpreadPctEnabled,
                    tightSpreadCentsEnabled,
                    setTightSpreadCentsEnabled,
                    optionPriceRangeEnabled,
                    setOptionPriceRangeEnabled,
                    tightSpreadPct,
                    dispatchTightSpreadPct,
                    tightSpreadCents,
                    dispatchTightSpreadCents,
                    optionPriceRange,
                    dispatchOptionPriceRange,
                    qtyRangeEnabled,
                    setQtyRangeEnabled,
                    dollarRangeEnabled,
                    setDollarRangeEnabled,
                    qtyRange,
                    dispatchQtyRange,
                    dollarRange,
                    dispatchDollarRange,
                    hugCurrentPriceEnabled,
                    setHugCurrentPriceEnabled,
                    hugCurrentPrice,
                    dispatchHugCurrentPrice,
                    setViewOptionManagementEnabled,
                    expirationDates,
                    setExpirationDates,
                    buyOrSellOption,
                    setBuyOrSellOption,
                    otm,
                    setOtm,
                    itm,
                    setItm,
                    notExpiringToday,
                    setNotExpiringToday,
                    true,
                    optionChoices,
                    setOptionChoices,
                    optionChains,
                    setOptionChains,
                    symbolsUsed,
                    setSymbolsUsed,
                    otm1Enabled,
                    setOtm1Enabled,
                    otm1,
                    dispatchOtm1,
                    itm1Enabled,
                    setItm1Enabled,
                    itm1,
                    dispatchItm1,
                  ]}
                  entryTactics={data.entryTactics}
                  setOptionsAvailable={setOptionsAvailable}
                />
              </Box>
            </Grid>
          </Grid>
          <Grid item container>
            <Grid item xs={12}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                padding={1}
                {...boxProps}
              >
                <Setup
                  top={top}
                  dispatchTop={dispatchTop}
                  setUpOptions={setUpOptions}
                  setupFields={setupFields}
                  dispatchSetUpDetails={dispatchSetUpDetails}
                  //setSavedConfigChanged={setSavedConfigChanged}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="stretch"
                border={1}
                {...boxProps}
              >
                <SetupFiltersTree
                  top={top}
                  includeDocsInLabel={true}
                  dispatchTop={dispatchTop}
                  setupFilters={[
                    priceIntersectsFirstCandleEnabled,
                    setPriceIntersectsFirstCandleEnabled,
                    priceIntersectsFirstCandle,
                    dispatchPriceIntersectsFirstCandle,
                    emaIntersectsFirstCandleEnabled,
                    setEmaIntersectsFirstCandleEnabled,
                    emaIntersectsFirstCandle,
                    dispatchEmaIntersectsFirstCandle,
                    timeOfDay,
                    dispatchTimeOfDay,
                    timeOfDayEnabled,
                    setTimeOfDayEnabled,
                    ftfcFilter,
                    dispatchFtfcFilter,
                    ftfcFilterEnabled,
                    setFtfcFilterEnabled,
                  ]}
                />
              </Box>
            </Grid>
          </Grid>
          <hr />
          <div className={style.splitWrapper}>
            <TradePlanTitleWrapper title="Entry Tactics">
              <EntryTacticsContainer
                top={top}
                marketOrder={[
                  marketOrder,
                  dispatchMarketOrder,
                  marketOrderEnabled,
                  setMarketOrderEnabled,
                ]}
                candleBreak={[
                  candleBreak,
                  dispatchCandleBreak,
                  candleBreakEnabled,
                  setCandleBreakEnabled,
                ]}
                limitOrder={[
                  limitOrder,
                  dispatchLimitOrder,
                  limitOrderEnabled,
                  setLimitOrderEnabled,
                ]}
              />
            </TradePlanTitleWrapper>
            <div className={style.verticalDivider} />
            <TradePlanTitleWrapper title="Position Tactics" rightSplit>
              <PositionTacticsContainer
                scalingIn={[
                  scalingIn,
                  dispatchScalingIn,
                  scalingInEnabled,
                  setScalingInEnabled,
                ]}
                addToWinner={[
                  addToWinner,
                  dispatchAddToWinner,
                  addToWinnerEnabled,
                  setAddToWinnerEnabled,
                ]}
                top={top}
              />
            </TradePlanTitleWrapper>
          </div>
          <hr />
          <TradePlanTitleWrapper title="Exit Tactics">
            <ExitTacticsContainer
              lossLimit={[
                lossLimit,
                dispatchLossLimit,
                lossLimitEnabled,
                setLossLimitEnabled,
              ]}
              preserveProfit={[
                preserveProfit,
                dispatchPreserveProfit,
                preserveProfitEnabled,
                setPreserveProfitEnabled,
              ]}
              positionPriceTrail={[
                positionPriceTrail,
                dispatchPositionPriceTrail,
                positionPriceTrailEnabled,
                setPositionPriceTrailEnabled,
              ]}
              underlyingPriceTrail={[
                underlyingPriceTrail,
                dispatchUnderlyingPriceTrail,
                underlyingPriceTrailEnabled,
                setUnderlyingPriceTrailEnabled,
              ]}
              candleTrail={[
                candleTrail,
                dispatchCandleTrail,
                candleTrailEnabled,
                setCandleTrailEnabled,
              ]}
              atrTrail={[
                atrTrail,
                dispatchAtrTrail,
                atrTrailEnabled,
                setAtrTrailEnabled,
              ]}
              underlyingPriceExit={[
                underlyingPriceExit,
                dispatchUnderlyingPriceExit,
                underlyingPriceExitEnabled,
                setUnderlyingPriceExitEnabled,
              ]}
              mfeRetracement={[
                mfeRetracement,
                dispatchMfeRetracement,
                mfeRetracementEnabled,
                setMfeRetracementEnabled,
              ]}
              grabCents={[
                grabCents,
                dispatchGrabCents,
                grabCentsEnabled,
                setGrabCentsEnabled,
                grabCentsMode,
                setGrabCentsMode,
              ]}
              greenToRedCandles={[
                greenToRedCandles,
                dispatchGreenToRedCandles,
                greenToRedCandlesEnabled,
                setGreenToRedCandlesEnabled,
              ]}
              greenToRedPositions={[
                greenToRedPositions,
                dispatchGreenToRedPositions,
                greenToRedPositionsEnabled,
                setGreenToRedPositionsEnabled,
              ]}
              breakPrice={[
                breakPrice,
                dispatchBreakPrice,
                breakPriceEnabled,
                setBreakPriceEnabled,
              ]}
              positionBreakPrice={[
                positionBreakPrice,
                dispatchPositionBreakPrice,
                positionBreakPriceEnabled,
                setPositionBreakPriceEnabled,
              ]}
              candleMagnitude={[
                candleMagnitude,
                dispatchCandleMagnitude,
                candleMagnitudeEnabled,
                setCandleMagnitudeEnabled,
              ]}
              ratchetBracket={[
                ratchetBracket,
                dispatchRatchetBracket,
                ratchetBracketEnabled,
                setRatchetBracketEnabled,
              ]}
              top={top}
            />
          </TradePlanTitleWrapper>
          <hr />
        </Grid>
        <Grid item>
          {top.dataSource === 'LIVE' ? (
            <StartPeriodHourMin top={top} dispatchTop={dispatchTop} />
          ) : (
            <></>
          )}
          {/*   </Box> */}
        </Grid>

        {
          <PushMessage
            message={submitMessageDetails['message']}
            severityScore={submitMessageDetails['severityScore']}
            open={clickedSubmit}
            setOpen={setClickedSubmit}
          />
        }
      </form>
    </ReactHotkeys>
  );
};
export default TradePlanForm;
